import { DataGrid, Column, Lookup } from "devextreme-react/data-grid";
import { statusKey } from "../../../../Components/OrderComponents/constants";

export default function HistoryTab(history) {
  return (
    <>
      <DataGrid
        id={`dataGridHistory${history[0].id}`}
        dataSource={history}
        showBorders={true}
        columnAutoWidth={true}
        maxHeight="300px"
        elementAttr={{ class: "history-grid" }}
      >
        <Column dataField="date" dataType="datetime" defaultSortOrder="desc" />
        <Column dataField="changedBy" />
        <Column dataField="status">
          <Lookup dataSource={statusKey} valueExpr="id" displayExpr="name" />
        </Column>
        <Column dataField="comment" />
      </DataGrid>
    </>
  );
}
